import { render } from "./_LinkAnchorButton.vue?vue&type=template&id=6f12c428&scoped=true&lang=en"
import script from "./_LinkAnchorButton.vue?vue&type=script&lang=js"
export * from "./_LinkAnchorButton.vue?vue&type=script&lang=js"

import "./_LinkAnchorButton.vue?vue&type=style&index=0&id=6f12c428&lang=scss&scoped=true"

import exportComponent from "/usr/local/var/www/website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f12c428"]])

export default __exports__